import { render, staticRenderFns } from "./RetryCampaignPackageCreationOnPlatformButton.vue?vue&type=template&id=24e1a346&scoped=true"
import script from "./RetryCampaignPackageCreationOnPlatformButton.vue?vue&type=script&lang=js"
export * from "./RetryCampaignPackageCreationOnPlatformButton.vue?vue&type=script&lang=js"
import style0 from "./RetryCampaignPackageCreationOnPlatformButton.vue?vue&type=style&index=0&id=24e1a346&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e1a346",
  null
  
)

export default component.exports